import { render, staticRenderFns } from "./PerimeterReportScreen.vue?vue&type=template&id=3207f744"
import script from "./PerimeterReportScreen.vue?vue&type=script&lang=js"
export * from "./PerimeterReportScreen.vue?vue&type=script&lang=js"
import style0 from "./PerimeterReportScreen.vue?vue&type=style&index=0&id=3207f744&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports